var map = {
	"./lesson_1_1.pdf": 941,
	"./lesson_1_2.pdf": 942,
	"./lesson_1_3.pdf": 943,
	"./lesson_1_4.pdf": 944,
	"./lesson_1_5.pdf": 945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;